import { SuccessfulApiResponse } from "@eryxcoop/appyx-comm";

export default class SummaryKpisResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                summary_kpis: {
                    billing_fulfillment: "85.40",
                    billing_fulfillment_vs_budget: "-14.60",
                    boxes_fulfillment: "70.20",
                    boxes_fulfillment_vs_budget: "-29.80",
                    elapsed_working_days: 12,
                    total_working_days: 26,
                    days_progress: "46.15",
                },
            },
            errors: [],
        };
    }

    summaryKpis() {
        const summaryKpis = this.content().summary_kpis;
        return {
            billingFulfillment: this._toNumber(summaryKpis.billing_fulfillment),
            billingFulfillmentVsBudget: this._toNumber(summaryKpis.billing_fulfillment_vs_budget),
            boxesFulfillment: this._toNumber(summaryKpis.boxes_fulfillment),
            boxesFulfillmentVsBudget: this._toNumber(summaryKpis.boxes_fulfillment_vs_budget),
            elapsedWorkingDays: summaryKpis.elapsed_working_days,
            totalWorkingDays: summaryKpis.total_working_days,
            daysProgress: this._toNumber(summaryKpis.days_progress),
        };
    }

    _toNumber(value) {
        return value == null ? null : Number(value);
    }
}
